import React, { Component } from 'react';
import Link from 'gatsby-link';
import NumberFormat from 'react-number-format';

class fePage extends Component {
    constructor(props) {
        super(props);      
           
    }

    componentDidMount(){

        if(!this.props.data.funnel){
            this.props.history.push('/');
        }

    }

    render() {

        return (
            <div className="midd_section_inner">
                <div className="midd_section_inner">
                    <div className="midd_heading_section">
                        <h1 className="fe_top_heading"> Funnel Assumptions</h1>
                        <p className="fe_paragraph">Great! PRO can optimize all the way down funnel. Can you let us know what the current conversion rates are all the way to revenue?
</p>
                    </div>
                    <table className="fe_table">
                        <thead>
                            <tr>
                                <th>CONVERSION RATE</th>
                                <th></th>
                                <th className="padding-left-50">VOLUME</th>
                                <th>VISITOR CONVERSION RATE</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Lead <span className="arro_img"></span> MQL </td>
                                <td className="fe_off small_input"> <NumberFormat data-max="100" thousandSeparator={true} allowNegative={false} data-rel="enLead_MQL" suffix={'%'} onValueChange={this.props.updateValue} value={this.props.data.enLead_MQL} /></td>
                                <td><span className="valumnField"><NumberFormat displayType="text" decimalScale={2} thousandSeparator={true}  value={this.props.data.outVolMQL} /> </span> MQLs per Month</td>
                                <td><NumberFormat displayType="text" decimalScale={2} thousandSeparator={true}  value={this.props.data.visConverRate} />%</td>
                            </tr>
                            <tr>
                                <td>MQL <span className="arro_img"></span> Opportunity </td>
                                <td className="fe_off small_input"> <NumberFormat data-max="100" thousandSeparator={true} allowNegative={false}   data-rel="enMQL_opp" suffix={'%'} onValueChange={this.props.updateValue} value={this.props.data.enMQL_opp} /></td>
                                <td><span className="valumnField"><NumberFormat displayType="text" decimalScale={2} thousandSeparator={true}  value={this.props.data.outVolOPP} /> </span>Opportunities per Month</td>
                                <td><NumberFormat displayType="text" decimalScale={2} thousandSeparator={true}  value={this.props.data.outOPPpm} />%</td>
                            </tr>
                            <tr>
                                <td>Opportunity <span className="arro_img"></span> Closed Won </td>
                                <td className="fe_off small_input"> <NumberFormat data-max="100" thousandSeparator={true} allowNegative={false}  data-rel="enOpp_CW" suffix={'%'} onValueChange={this.props.updateValue} value={this.props.data.enOpp_CW} /></td>
                                <td><span className="valumnField"><NumberFormat displayType="text" decimalScale={2} thousandSeparator={true}  value={this.props.data.outVolCW} /></span> Closed Won per Month</td>
                                <td><NumberFormat displayType="text" decimalScale={2} thousandSeparator={true}  value={this.props.data.outCWpm} />%</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="fe_btn_formatting style_2 step1">
                    <div className="btn back_btn"> <Link to="/"   > back </Link></div>
                    <div className="btn next_btn"  data-enable={this.props.data['revenue-ltv']}> <Link to="revenue-ltv" > next </Link></div>
                </div>
            </div>
        );
    }
}

export default fePage;


// WEBPACK FOOTER //
// ./src/pages/funnel.js